import { notification } from 'antd';

export const CLICK_TYPE = {
  NODE: 'NODE',
  POINTER: 'POINTER',
  OTHERS: 'OTHERS',
};

export const notifyError = (description) => {
  notification.error({
    message: '操作失败',
    description: description,
  });
};

export const notifySuccess = (description) => {
  notification.success({
    title: '操作成功',
    description: description,
  });
};

export const notifyInfo = (description) => {
  notification.info({
    title: '提示',
    description: description,
  });
};
